import consumer from "./consumer"

consumer.subscriptions.create("NotificationsChannel", {
  connected() {},
  disconnected() {},
  received(data) {
    if (window.NotificationsUI) {
      window.NotificationsUI.handleCableMessage(data)
    }
  }
})
